import React from 'react';
import styled from 'styled-components';

const VideoWrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
  margin-bottom: 2rem;

  iframe, object, embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const YoutubePlayer = (id) => {
  return `<iframe src="https://www.youtube-nocookie.com/embed/${id}?rel=0&amp;showinfo=0" width="844" height="475" frameborder="0" allowfullscreen></iframe>`;
};

const VimeoPlayer = (id) => {
  return `<iframe src="https://player.vimeo.com/video/${id}" width="844" height="475" frameborder="0" allowfullscreen></iframe>`;
};

const playerByType = (type) => {
  switch(type) {
    case 'youtube':
      return YoutubePlayer;
    case 'vimeo':
      return VimeoPlayer;
    default :
      return null;
  }
};

const VideoPlayer = (props) => {
  const { 
    type,
    id,
  } = props;

  const player = playerByType(type);
  if(!player) return null;

  return (
    <VideoWrapper dangerouslySetInnerHTML={{ __html: player(id) }} />
  );
  /*

  return (
    type === 'youtube' && (
      <VideoWrapper dangerouslySetInnerHTML={{ __html: YoutubePlayer(id) }} />
    )
    type === 'youtube' && (
      <VideoWrapper dangerouslySetInnerHTML={{ __html: YoutubePlayer(id) }} />
    )
  );
  */
};

export default VideoPlayer;


// WEBPACK FOOTER //
// ./src/modules/content/components/VideoPlayer.js